import React, { FC, InputHTMLAttributes, forwardRef } from 'react';

import { FormInputWrapper, FormInputContainer, ErrorText } from './FileInput.style';
import {
  AccordionArrow,
  UploadFileIcon,
  UploadIcon,
  CameraIcon,
  PictureIcon,
} from 'src/components/base/core/Media/Icon/Icons/Icons';
import { Typography } from '@mui/material';

export type InputType = 'file';

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  htmlFor?: string;
  error?: any;
  maxWidth?: string;
  isActive?: boolean;
  readOnly?: boolean;
  isRequired?: boolean;
  isCaptureButton?: boolean;
  isReplace?: boolean;
  fileString?: string;
  isFront?: boolean;
  documentType?: any;
  fileValue?: any;
  onChange?: any;
  id?: string;
  label?: string;
}

export const FileInput: FC<InputProps> = forwardRef<HTMLInputElement, InputProps>(
  (
    {
      htmlFor,
      error,
      maxWidth = '100%',
      inputMode = 'text',
      isActive,
      readOnly,
      isRequired = false,
      isCaptureButton = false,
      isReplace,
      fileString,
      isFront = true,
      documentType,
      fileValue,
      id,
      label,
      ...props
    },
    ref
  ) => {
    return (
      <FormInputWrapper style={{ maxWidth: maxWidth }} className={readOnly ? 'active' : 'inActive'}>
        <FormInputContainer className={isActive ? 'active' : 'inActive'}>
          <input
            id={id}
            ref={ref}
            type={'file'}
            aria-label={label}
            inputMode={inputMode}
            {...props}
          />
          <label htmlFor={id}>
            <div className="label_left">
              <div className="left_icon_block">
                {!isCaptureButton && <UploadIcon />}
                {isCaptureButton && <CameraIcon />}
              </div>
              <Typography variant="h2Bold" color={'gray.800'}>
                {label}
              </Typography>
            </div>

            <div className="label_right">
              {isReplace && (
                <div className="doc_indication">
                  {!isCaptureButton && <UploadFileIcon />}
                  {isCaptureButton && <PictureIcon />}
                  <Typography
                    variant="h2Bold"
                    color={'gray.800'}
                    textTransform={isCaptureButton ? 'uppercase' : 'capitalize'}
                  >
                    {fileValue}
                  </Typography>
                </div>
              )}

              {!isReplace && (
                <div className="arrow_icon_wrapper">
                  <AccordionArrow />
                </div>
              )}
            </div>
          </label>
        </FormInputContainer>
        {error && <ErrorText>{error}</ErrorText>}
      </FormInputWrapper>
    );
  }
);
